export const TITLE = '痞客邦PIXNET-掌握最新熱門話題貼文、短影音，讓生活充滿靈感!';
export const DESCRIPTION = '痞客邦提供部落格、短貼文、短影音等自媒體網路平台服務，匯集最新活動資訊熱搜話題，涵蓋美食、旅遊、親子、影視、美妝等文章，快來一起分享更多生活靈感與挑戰吧！';
export const KEYWORDS = '痞客邦,pixnet,部落格';
export const OG_IMAGE = 'https://www.pixnet.net/img/public/OG.png';
